<template>
  <el-dialog
    :visible="true"
    :before-close="handleClose"
    :title="$t('物质库信息')"
    width="800px"
    class="mn606-alarm-threshold-settings"
    top="10vh"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
    element-loading-text="Loading"
  >
    <div class="alarm-threshold-settings-611_content scrollbar-thin">
      <el-table :data="verticalData" border style="width: 100%" :show-header="false">
        <el-table-column prop="label" label=""></el-table-column>
        <el-table-column prop="value" label=""></el-table-column>

        <!-- <el-table-column prop="CWA" label="CWA"></el-table-column>
        <el-table-column prop="TIC" label="TIC"></el-table-column> -->
      </el-table>
    </div>
    <div class="action-wrap">
      <el-button @click="handleClose(null)" :loading="loading">{{ $t('关闭') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    sn: {
      type: String,
      default: ''
    },
    container: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  computed: {
    ...mapState('socket', ['devicesSourseMap', 'deviceSNMap']),

    currentChooseDevice() {
      return this.deviceSNMap[this.sn || this.$route.params.sn];
    }
  },
  data() {
    return {
      i18nPath: 'component.bmap',
      loading: false,
      saveLoading: false,
      verticalData: []
    };
  },
  methods: {
    initBasicData() {
      const rawData = {
        CWA: '塔崩、沙林、维埃克斯、梭曼、甲氟磷酸环己酯、芥子气、路易士气、氮芥1、氮芥2、氮芥3、氯化氰、氢氰酸、光气、双光气、毕兹、GSI、HSI',
        TIC: '苯酚、氯化氢、氯气'
      };
      const headers = [
        { label: 'CWA', prop: 'CWA' },
        { label: 'TIC', prop: 'TIC' }
      ];

      this.verticalData = this.transformData(headers, rawData);
    },
    transformData(headers, data) {
      return headers.map(header => ({
        label: header.label,
        value: data[header.prop]
      }));

      //   return [
      //     {
      //       CWA: data.CWA,
      //       TIC: data.TIC
      //     }
      //   ];
    },
    reset(index) {
      Object.assign(this.tableConfig.data[index], this.rawData[index]);
    },

    handleClose(done) {
      this.$destroy();
      if (done) done?.();
    }
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.initBasicData();
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.mn606-alarm-threshold-settings {
  box-sizing: border-box;

  &_content {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .el-dialog {
    height: calc(100vh - 20vh);

    max-width: 65vw;

    &__body {
      height: calc(100% - 55px);
      box-sizing: border-box;
    }

    .action-wrap {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
